import {
  House,
  UserCheck,
  ListChecks,
  SearchCheck,
  Flag,
  CircleDollarSign,
  FileText,
  UsersRound,
  HeartHandshake,
  BookOpen,
} from "lucide-react";

import { POST_LOSS_ROUTES } from "@/shared/constants/paths";
import type { NavSection } from "@/pages/layouts/components/nav/NavMain";

export function getModuleUrl(moduleId: string): string {
  return `/${moduleId}`;
}

export const NAV_SECTIONS: NavSection[] = [
  {
    label: "",
    items: [
      {
        title: "Home",
        url: POST_LOSS_ROUTES.OVERVIEW,
        icon: House,
      },
    ],
  },
  {
    label: "Your journey",
    items: [
      {
        title: "Get authorized",
        url: POST_LOSS_ROUTES.GET_AUTHORIZED,
        icon: UserCheck,
      },
      {
        title: "Important to-dos",
        url: POST_LOSS_ROUTES.ESTATE_ESSENTIALS,
        icon: ListChecks,
      },
      {
        title: "Find assets",
        url: POST_LOSS_ROUTES.FIND_ASSETS,
        icon: SearchCheck,
      },
      {
        title: "Settle the estate",
        url: POST_LOSS_ROUTES.SETTLE_ESTATE,
        icon: Flag,
      },
    ],
  },
  {
    label: "Estate record",
    items: [
      {
        title: "Summary",
        url: POST_LOSS_ROUTES.SUMMARY,
        icon: BookOpen,
      },
      {
        title: "Assets & debts",
        url: POST_LOSS_ROUTES.ESTATE_INVENTORY,
        icon: CircleDollarSign,
      },
      {
        title: "Documents",
        url: POST_LOSS_ROUTES.DOCUMENTS,
        icon: FileText,
      },
      {
        title: "Contacts",
        url: POST_LOSS_ROUTES.CONTACTS,
        icon: UsersRound,
      },
      {
        title: "Community & resources",
        url: POST_LOSS_ROUTES.RESOURCES,
        icon: HeartHandshake,
      },
    ],
  },
];
